module.exports = __webpack_public_path__ + "img/sjzb.2635cc47.png";